module.exports = __webpack_public_path__ + "static/img/door-white.0dc819b7.png";